import React, { useEffect, useContext, useRef } from 'react';

import { FiSearch } from 'react-icons/fi';

import { Navbar, Footer, Sidebar } from '../../components';
import { useStateContext } from '../../context/ContextProvider';
import BlogCard from './BlogCard';

import Header from './Header';
import BlogContext from '../../context/blog/blogContext';
import Loading from './Loading';

const Blogs = () => {
  const blogContext = useContext(BlogContext);
  const { blogs, filtered, filterBlogs, clearFilter, getBlogs } = blogContext;
  const text = useRef('');

  const onChange = (e) => {
    if (e.target.value !== '') {
      filterBlogs(e.target.value);
    } else {
      text.current.value = '';
      clearFilter();
    }
  };

  const { setCurrentColor, setCurrentMode, currentMode, activeMenu } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  useEffect(() => {
    getBlogs();
  }, []);

  const handleClear = () => {
    clearFilter();
  };
  const RenderLoadings = () => {
    const loadings = [];

    for (let i = 0; i < 10; i += 1) {
      loadings.push(<Loading key={i} />);
    }

    return loadings;
  };


  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <div className="flex relative  dark:bg-main-dark-bg">

        {activeMenu ? (
          <div className="w-52 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
        <div
          className={
            activeMenu
              ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-52 w-full  '
              : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
          }
        >
          <div className="fixed h-12 md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
            <Navbar />
          </div>

          <Header />

          <div className="mt-8 text-gray-900  pr-0 pb-14 pl-0">
            <div className="mb-8 w-[90%]">
              <div className="pt-0 pr-4 pb-0 pl-4 mt-0 mr-auto mb-0 ml-auto sm:flex sm:items-center sm:justify-around">
                <div>
                  <h2 className="mb-4 text-center text-2xl font-bold text-gray-800 dark:text-white md:text-4xl">
                    Unleash Your Inner Gearhead
                  </h2>
                  <p className="text-gray-600 dark:text-gray-300 lg:mx-auto lg:w-8/12">
                    Exploring the Exciting World of Vehicles
                  </p>
                </div>

                <div className="mt-4 mr-0 mb-0 ml-0 sm:mt-0">
                  <p className="sr-only">Search</p>
                  <div className="relative">
                    <div className="flex items-center pt-0 pr-24 pb-0 pl-2 absolute inset-y-0 left-0 pointer-events-none">
                      <FiSearch className="w-5 h-5 text-gray-400" />
                    </div>

                    <input
                      placeholder="Search... "
                      type="text"
                      ref={text}
                      onChange={onChange}
                      className="block  pt-3 pr-0 pb-3 pl-24 lg:mx-auto lg:w-full py-3 border border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
                    />
                  </div>

                  {filtered
                    && (
                    <button
                      type="button"
                      onClick={handleClear}
                      className="  pt-3 pr-0 pb-3 lg:mx-auto lg:w-full py-3 border border-gray-300 rounded-lg sm:text-sm"
                    >clear filter
                    </button>
                    )}

                </div>
              </div>
            </div>
            {blogs ? (
              <div id="read" className="w-full pt-2 pr-5 pb-6 pl-5 mt-0 mr-auto mb-0 ml-auto space-y-5 sm:py-8 md:py-12 sm:space-y-8 md:space-y-16 max-w-7xl">
                <div className="grid grid-cols-12 sm:px-5 gap-x-8 gap-y-16">
                  {
                      filtered !== null
                        ? filtered.map((blog) => (
                          <BlogCard blogPost={blog} />
                        ))
                        : blogs.map((blog) => (
                          <BlogCard blogPost={blog} />
                        ))
                    }
                </div>
              </div>
            )
              : (
                <div className="mx-8 grid gap-32 py-20 md:grid-cols-3 md:gap-12">
                  <RenderLoadings />
                </div>
              )}
          </div>
          {/* <CarouselCard /> */}
          <Footer />
        </div>
      </div>
    </div>

  );
};
export default Blogs;
